export default "{\n    \"toolTips\": {\n        \"suggestUpgrade\": \"Upgrade your plan to access this feature\"\n    }\n}\n"